// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "desktop_NewBuildingSearchRoute" + "_" + "a8efb43afc0a5627a0a9" + ".css";
};